<template>
  <div id="app">
    <!-- page wrapper -->
    <div class="dev-page">
      <!-- page header -->
      <div class="dev-page-header">

        <div class="dph-logo">
          <a href="#">WY - SHPO</a>
          <a class="dev-page-sidebar-collapse">
            <div class="dev-page-sidebar-collapse-icon">
              <span class="line-one"></span>
              <span class="line-two"></span>
              <span class="line-three"></span>
            </div>
          </a>
        </div>
        <ul class="dph-buttons pull-right">
          <li v-on:click="login()" v-if="!authenticated">
            <a href="#">Log In</a>
          </li>
          <li v-if="authenticated"><span style="line-height: 55px; margin-right: 30px; display: inline-block; vertical-align: middle;">{{profile.authProfile && profile.authProfile.email }}</span></li>
          <li v-if="authenticated && hasUserOrganizationList()"><a href="#"><span style="margin-right: 20px; display: inline-block; vertical-align: middle;">{{ getFirstOrganization() }}</span></a></li>
          <li v-on:click="logout()" v-if="authenticated">
            <a href="#">
              <img v-bind:src="(profile.authProfile || {}).picture" height="25" width="25" /><span style="margin-left: 5px; display:inline-block; vertical-align: middle;">Log Out</span>
            </a>
          </li>
        </ul>
        <spinner v-show="httpRunning" />
      </div>
      <!-- ./page header -->

      <!-- page container -->
      <div class="dev-page-container">
        <!-- page sidebar -->
        <div class="dev-page-sidebar">
          <ul class="dev-page-navigation">
            <li class="title">NAVIGATION</li>
            <li><a v-if="!authenticated" v-on:click="login()"><i class="glyphicon glyphicon-log-in"></i>Log In</a></li>
            <li v-if="!authenticated"><router-link to="/PublicE106" tag="a">Submit E106</router-link></li>
            <li v-if="authenticated && hasRoleList && !isPublicUser"><router-link to="/HelpInfo" tag="a">Getting Started</router-link></li>
            <li v-if="authenticated && hasRoleList && !isPublicUser" class="has_child">
              <router-link to="/Dashboard" tag="a"><i class="fa fa-desktop"></i>Dashboard</router-link>
              <ul v-if="isCLGConsultantE106User">
                <li><router-link to="/Projects" tag="a">Projects</router-link></li>
              </ul>
              <ul v-else>
                <li><router-link to="/Projects" tag="a">Projects</router-link></li>
                <li v-if="!isViewOnlyUser"><router-link to="/FieldWorkRequests" tag="a">Field Work Requests</router-link></li>
                <li v-if="!isViewOnlyUser"><router-link to="/FileSearches" tag="a">File Search</router-link></li>
                <li><router-link to="/Investigations" tag="a">Investigations</router-link></li>
                <li v-if="!isConsultant && !isViewOnlyUser"><router-link to="/Undertakings" tag="a">Undertakings</router-link></li>
                <li v-if="!isConsultant && !isViewOnlyUser"><router-link to="/MoasPas" tag="a">MOAs / PAs</router-link></li>
                <li v-if="!isViewOnlyUser"><router-link to="/Map" tag="a">Map</router-link></li>
                <li><router-link to="/MapPublic" tag="a">Risk Layer Map</router-link></li>
                <li v-if="!isViewOnlyUser"><router-link to="/CulturalResources" tag="a">Production Record Search</router-link></li>
                <li v-if="isAdmin" class="has-child" v-on:click="toggleNavItem('isAdminHidden')">
                    <a href="#">Administration</a>
                    <ul>
                        <li v-bind:class="{ 'child-nav': isAdminHidden }"><router-link to="/Organization" tag="a">Organization</router-link></li>
                        <li v-bind:class="{ 'child-nav': isAdminHidden }"><router-link to="/UserAdministration" tag="a">User Administration</router-link></li>
                        <li v-bind:class="{ 'child-nav': isAdminHidden }"><router-link to="/LetterTemplates" tag="a">Letter Templates</router-link></li>
                        <li v-bind:class="{ 'child-nav': isAdminHidden }"><router-link to="/ProjectsDelete" tag="a">Delete Projects</router-link></li>
                    </ul>
                </li>
                <li v-if="!isViewOnlyUser" class="has-child" v-on:click="toggleNavItem('isMiscHidden')">
                    <a href="#">Miscellaneous</a>
                    <ul>
                        <li v-if="!isViewOnlyUser" v-bind:class="{ 'child-nav': isMiscHidden }"><router-link to="/SiteNumberRequests" tag="a">Off inventory site number request</router-link></li>
                        <li v-if="isAdmin" v-bind:class="{ 'child-nav': isMiscHidden }"><router-link to="/BlmDataExport" tag="a">BLM Data Export</router-link></li>
                    </ul>
                </li>
              </ul>
            </li>
            <li v-if="authenticated && !isPublicUser" class="has_child">
                <ul>
                    <li v-if="!isViewOnlyUser"><router-link to="/Reports" tag="a">Reports</router-link></li>
                </ul>
            </li>
            <li v-if="authenticated && isPublicUser" class="has_child">
                <ul>
                    <li><router-link to="/MapPublic" tag="a">Map</router-link></li>
                </ul>
            </li>
            <li v-if="authenticated && (!hasRoleList || isShpo)" class="has_child">
                <ul>
                    <li><router-link to="/UserInfo" tag="a">User Info</router-link></li>
                </ul>
            </li>
          </ul>
        </div>
        <!-- ./page sidebar -->

        <div class="errorMessages alert alert-danger alert-dismissible" v-if="errorList.length > 0">
            <button type="button" class="close" aria-label="Close" v-on:click="errorMessageClear()"><span aria-hidden="true">×</span></button>
            <div class="has-error" style="margin-bottom: 10px; border-bottom: 1px solid;">Errors have occurred:</div>
            <div class="has-error" style="margin-left: 10px;">
                <div v-for="error in errorList" v-bind:key="error.id" style="margin-bottom: 10px; border-bottom: 1px solid;">
                    {{ error.time }}<br/>
                    {{ error.status }}{{ error.message }}<br/>
                    {{ error.url }}<br/>
                </div>
            </div>
        </div>

        <!-- page content -->
        <div class="dev-page-content" style="border: 1px 1px 1px 1px;">
          <!-- page content container -->
          <div class="container">

            <!-- page title -->
            <div class="page-title">
                <transition name="fade" mode="out-in">
                    <div>
                    <router-view :auth="auth" :authenticated="authenticated"></router-view>
                    </div>
                </transition>
                <div v-if="!authenticated">
                    {{loginMessage}}
                </div>
                <div v-if="isDebug">
                    <hr />

                    <div style="float: left; margin-left: 30px; margin-top: 50px;">
                        <div style="text-align: left; display: inline-block; vertical-align: top;">
                            authenticated: {{ authenticated }}<br />

                            <div v-if="authenticated" style="margin-top: 10px;">
                            name: {{ (profile.authProfile || {}).name }}<br />
                            email: {{ (profile.authProfile || {}).email }}<br />
                            user_id: {{ (profile.authProfile || {}).user_id }}<br />
                            roleList: {{ shpoUserDto && shpoUserDto.roleList }}<br />
                            userOrganizationList: {{  shpoUserDto && shpoUserDto.userOrganizationList }}<br />
                            <!-- loginPlaceholder: {{ loginPlaceholder }}<br /> -->
                            is idle: {{ isAppIdle }}
                            </div>
                        </div>
                    </div>
                </div>
                <time-out-modal :auth="auth" :authenticated="authenticated" />
            </div>
            <!-- ./page title -->

            <!-- page footer -->
            <div class="dev-page-footer" style="display: flex; justify-content: space-evenly; align-items: center;">
                <div style="padding: 5px; font-size: 14px;">
                    <a style="color: white;" href="http://ag.wyo.gov/privacy" target="_blank">Privacy Policy</a>
                </div>
                <div style="padding: 5px; font-size: 11px;">
                    <div>Wyoming State Historic Preservation Office</div>
                    <div>2301 Central Ave.
                    Barrett Building - 3rd Floor
                    Cheyenne, WY 82002</div>
                    <div><a style="color: white;" href="mailto:spcr.wycro@wyo.gov">spcr.wycro@wyo.gov</a></div>
                </div>
            </div>
          </div>
            <!-- ./page content -->

          <!-- ./page content container -->
          <!-- ./page container -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import 'bootstrap'
    import 'bootstrap/dist/css/bootstrap.min.css'
    import './css/default-blue-white.css'

    import 'jquery-ui/ui/widgets/tooltip'
    import 'malihu-custom-scrollbar-plugin'
    import 'jquery-knob'
    import 'jquery-sparkline'

    import VueRouter from 'vue-router'
    import { mapState } from 'vuex'

    import spinner from './components/Spinner.vue'
    import timeOutModal from './components/TimeoutModal.vue'
    import loggingService from './services/util/loggingService'
    import dateService from './services/util/dateService'
    import userService from './services/userService'
    import roleService from '@/services/roleService.js'
    import { Validator } from 'vee-validate'
    // import './js/dev-app.js'

    import AuthService from '@/auth0/AuthService'
    import utilService from '@/services/util/utilService'

    import devLayout from './js/dev-layout-default.js'

    const auth = new AuthService()
    const { login, logout, authenticated, authNotifier, renewTokens } = auth

    export default {
        components: {
            VueRouter,
            spinner,
            timeOutModal
        },
        name: 'app',
        data: function () {
            authNotifier.on('authChange', authState => {
                loggingService.log(this.isDebug, 'App.vue', 'authNotifier - authChange')
                this.authenticated = authState.authenticated
                this.authResult = authState.authResult
                if (authState.authenticated) {
                    this.$store.dispatch('auth/authenticated', this.authResult).then(
                        val => {
                            this.onAuthenticated('Created')
                            //set interval to renew token
                            let expiredAtMs = JSON.parse(localStorage.getItem('expires_at') - new Date().getTime())
                            loggingService.log(this.isDebug, 'App.vue - Expire At', `session will expire in ${expiredAtMs / 1000} seconds`)
                            if (expiredAtMs > 0) {
                                let renewTimer = expiredAtMs - 120000 > 0 ? expiredAtMs - 120000 : 60000
                                loggingService.log(this.isDebug, 'App.vue - Renew Timer', `renew timer set in ${renewTimer / 1000} seconds`)
                                setTimeout(() => {
                                    loggingService.log(this.isDebug, 'App.vue', `renew timer triggered`)
                                    if (utilService.isAppIdle()) {
                                        loggingService.log(this.isDebug, 'App.vue', `user is idle, logging out...`)
                                        this.auth.logout()
                                    } else {
                                        loggingService.log(this.isDebug, 'App.vue', `user is active, renew token...`)
                                        this.auth.renewTokens()
                                    }
                                }, renewTimer)
                            }
                        },
                        err => { console.log('dispatch.then error: ' + err) }
                    )
                    this.$store.commit('clearErrors')
                } else {
                    loggingService.log(this.isDebug, 'Full.vue - authNotifier', ' not authenticated')
                    //this.$store.dispatch('logout')
                }
            })
            return {
                auth,
                authenticated,
                authResult: {},
                isDebug: false,
                getResultList: [],
                getSecureResultList: [],
                isMiscHidden: true,
                isAdminHidden: true,
                loginMessage: '' //use this for any login messages
            }
        },
        computed: {
            ...mapState({
                profile: state => state.auth.shpoProfile || {},
                shpoUserDto: state => state.auth.shpoUserDto,
                httpRunning: state => state.httpRunning,
                errorList: state => state.errorList
            }),
            isAdmin: function () {
                return (this.shpoUserDto && userService.hasRoleCheck(this.shpoUserDto.roleList, roleService.AdminRoleList))
            },
            isConsultant: function () {
                return (this.shpoUserDto && userService.hasRoleCheck(this.shpoUserDto.roleList, [roleService.RoleEnum.ConsultantUser]))
            },
            isCLGConsultantE106User: function () {
                return (this.shpoUserDto && userService.hasRoleCheck(this.shpoUserDto.roleList, [roleService.RoleEnum.CLGConsultant, roleService.RoleEnum.E106User]))
            },
            isBlm: function () {
                return (this.shpoUserDto && userService.hasRoleCheck(this.shpoUserDto.roleList, [roleService.RoleEnum.BlmUser]))
            },
            isShpo: function () {
                return (this.shpoUserDto && userService.hasRoleCheck(this.shpoUserDto.roleList, roleService.ShpoRoleList))
            },
            isViewOnlyUser: function () {
                return userService.hasRoleCheck(this.shpoUserDto.roleList, roleService.ViewOnlyRoleList)
            },
            hasRoleList: function () {
                return this.shpoUserDto && this.shpoUserDto.roleList && this.shpoUserDto.roleList.length > 0
            },
            isPublicUser: function () {
                return (this.shpoUserDto && userService.hasRoleCheck(this.shpoUserDto.roleList, [roleService.RoleEnum.PublicUser]))
            }
        },
        async created () {
            this.appendCssFile()
            //load dev-layout-default.js
            devLayout()

            var handle = this
            window.addEventListener('beforeunload', (event) => {
                localStorage.setItem('shpo_browser_unload', new Date())
            })
            try {
                await renewTokens()
            } catch (e) {
                loggingService.log(this.isDebug, 'App.vue', 'renewToken - error')
                loggingService.logRaw(this.isDebug, e)
            }

            //create interval to store last active time
            localStorage.setItem('shpoAppActive', new Date())
            setInterval(() => {
                if (!this.isAppIdle) {
                    localStorage.setItem('shpoAppActive', new Date())
                }
            }, 1000)

            // if (this.authenticated) {
            //     loggingService.log(this.isDebug, 'App.vue', 'user authenticated')
            //     this.$store.dispatch('auth/authenticated', this.authResult).then(
            //         val => {
            //             this.onAuthenticated('Created')
            //             //set interval to renew token
            //             let expiredAtMs = JSON.parse(localStorage.getItem('expires_at') - new Date().getTime())
            //             loggingService.log(this.isDebug, 'App.vue - Expire At', `session will expire in ${expiredAtMs / 1000} seconds`)
            //             if (expiredAtMs > 0) {
            //                 let timer = expiredAtMs - 120000 > 0 ? expiredAtMs - 120000 : 60000
            //                 loggingService.log(this.isDebug, 'App.vue - Renew Timer', `renew timer set at ${timer / 1000} seconds`)
            //                 setTimeout(() => {
            //                     if (this.isIdle) {
            //                         this.logout()
            //                     } else {
            //                         //renewTokens()
            //                         this.$router.go()
            //                     }
            //                 }, timer)
            //             }
            //         },
            //         err => { console.log('dispatch.then error: ' + err) }
            //     )
            //     this.$store.commit('clearErrors')
            // }

            Validator.extend('validSection', {
                getMessage (field, args) {
                    var meridianId = Number.parseInt(args[0])
                    var dimension = args[1]
                    loggingService.log(handle.isDebug, 'Validator-validSection', 'message for value ' + field + ' against ' + meridianId + ' and ' + dimension)
                    var meridianBounds = [
                        {
                            meridianId: 1,
                            township: { min: 12, max: 59 },
                            range: { min: 60, max: 121 }
                        },
                        {
                            meridianId: 2,
                            township: { min: 1, max: 9 },
                            range: { min: 1, max: 6 }
                        }
                    ]
                    var bound = meridianBounds.find(x => { return x.meridianId === meridianId })[dimension]
                    if (!bound) {
                        return 'The section is not valid'
                    } else {
                        return `The ${dimension} must be between ${bound.min} and ${bound.max}`
                    }
                },
                validate (value, args) {
                    var meridianId = Number.parseInt(args[0])
                    var dimension = args[1]
                    if (!meridianId && !dimension) {
                        loggingService.log(handle.isDebug, 'Validator-validSection', 'trying to validate unknowns, return false')
                        return false
                    }
                    loggingService.log(handle.isDebug, 'Validator-validSection', `validating value ${value} against ${meridianId} and ${dimension}`)
                    var meridianBounds = [
                        {
                            meridianId: 1,
                            township: { min: 12, max: 59 },
                            range: { min: 60, max: 121 }
                        },
                        {
                            meridianId: 2,
                            township: { min: 1, max: 9 },
                            range: { min: 1, max: 6 }
                        }
                    ]

                    var bound = meridianBounds.find(x => { return x.meridianId === meridianId })[dimension]
                    loggingService.log(handle.isDebug, 'Validator-validSection', `bound ${bound} ${bound.min} and ${bound.max}`)

                    if (!bound) {
                        loggingService.log(handle.isDebug, 'Validator-validSection', `did not find bounds, failed`)
                        return false
                    }
                    if (bound.min <= value && value <= bound.max) {
                        loggingService.log(handle.isDebug, 'Validator-validSection', `Validation passed`)
                        return true
                    } else {
                        loggingService.log(handle.isDebug, 'Validator-validSection', `Validation failed`)
                        return false
                    }
                }
            })

            Validator.extend('validPlssDirection', {
                getMessage (field, args) {
                    var meridianId = Number.parseInt(args[0])
                    var dimension = args[1]
                    loggingService.log(handle.isDebug, 'Validator-validSection', 'message for value ' + field + ' against ' + meridianId + ' and ' + dimension)
                    var meridianBounds = [
                        {
                            meridianId: 1,
                            township: ['N'],
                            range: ['W']
                        },
                        {
                            meridianId: 2,
                            township: ['N', 'S'],
                            range: ['W', 'E']
                        }
                    ]
                    var bound = meridianBounds.find(x => { return x.meridianId === meridianId })[dimension]
                    if (!bound) {
                        return 'The section is not valid'
                    } else {
                        return `The ${dimension} must be ${bound.join(', ')}`
                    }
                },
                validate (value, args) {
                    var meridianId = Number.parseInt(args[0])
                    var dimension = args[1]
                    if (!meridianId && !dimension) {
                        loggingService.log(handle.isDebug, 'Validator-validSection', 'trying to validate unknowns, return false')
                        return false
                    }
                    loggingService.log(handle.isDebug, 'Validator-validSection', `validating value ${value} against ${meridianId} and ${dimension}`)
                    var meridianBounds = [
                        {
                            meridianId: 1,
                            township: ['N'],
                            range: ['W']
                        },
                        {
                            meridianId: 2,
                            township: ['N', 'S'],
                            range: ['W', 'E']
                        }
                    ]

                    var bound = meridianBounds.find(x => { return x.meridianId === meridianId })[dimension]
                    loggingService.log(handle.isDebug, 'Validator-validSection', `bound ${bound} ${bound.min} and ${bound.max}`)

                    if (!bound) {
                        loggingService.log(handle.isDebug, 'Validator-validSection', `did not find bounds, failed`)
                        return false
                    }
                    if (bound.includes(value)) {
                        loggingService.log(handle.isDebug, 'Validator-validSection', `Validation passed`)
                        return true
                    } else {
                        loggingService.log(handle.isDebug, 'Validator-validSection', `Validation failed`)
                        return false
                    }
                }
            })

            Validator.extend('validUtm', {
                getMessage (field, args) {
                    var UtmId = Number.parseInt(args[0])
                    var fieldName = args[1]
                    loggingService.log(handle.isDebug, 'Validator-validUtm', 'message for value ' + field + ' against ' + UtmId + ' and ' + fieldName)
                    var coordinateBounds = [
                        {
                            UtmId: 1,
                            Easting: { min: 487000, max: 753000 },
                            Northing: { min: 4537500, max: 4995500 }
                        },
                        {
                            UtmId: 2,
                            Easting: { min: 246900, max: 580400 },
                            Northing: { min: 4537800, max: 4988200 }
                        }
                    ]
                    var bound = coordinateBounds.find(x => { return x.UtmId === UtmId })[fieldName]
                    if (!bound) {
                        return 'The section is not valid'
                    } else {
                        return `${fieldName} must be between ${bound.min} and ${bound.max}`
                    }
                },
                validate (value, args) {
                    var UtmId = Number.parseInt(args[0])
                    var fieldName = args[1]
                    if (!UtmId && !fieldName) {
                        loggingService.log(handle.isDebug, 'Validator-validUtm', 'trying to validate unknowns, return false')
                        return false
                    }
                    loggingService.log(handle.isDebug, 'Validator-validUtm', `validating value ${value} against ${UtmId} and ${fieldName}`)
                    var coordinateBounds = [
                        {
                            UtmId: 1,
                            Easting: { min: 487000, max: 753000 },
                            Northing: { min: 4537500, max: 4995500 }
                        },
                        {
                            UtmId: 2,
                            Easting: { min: 246900, max: 580400 },
                            Northing: { min: 4537800, max: 4988200 }
                        }
                    ]

                    var bound = coordinateBounds.find(x => { return x.UtmId === UtmId })[fieldName]
                    loggingService.log(handle.isDebug, 'Validator-validUtm', `bound ${bound} ${bound.min} and ${bound.max}`)

                    if (!bound) {
                        loggingService.log(handle.isDebug, 'Validator-validUtm', `did not find bounds, failed`)
                        return false
                    }
                    if (bound.min <= value && value <= bound.max) {
                        loggingService.log(handle.isDebug, 'Validator-validUtm', `Validation passed`)
                        return true
                    } else {
                        loggingService.log(handle.isDebug, 'Validator-validUtm', `Validation failed`)
                        return false
                    }
                }
            })
        },
        methods: {
            login,
            logout,
            onAuthenticated (type) {
                loggingService.log(this.isDebug, 'App.vue', 'onAuthenticated - ' + type + ' - ' + dateService.toStringNow())
                var result = userService.validate(this.profile, this.shpoUserDto.roleList, this.shpoUserDto.userOrganizationList)
                if (!result.isValid) {
                    this.$router.push('/UserInfo')
                }
            },
            hasUserOrganizationList () {
                if (!this.shpoUserDto) {
                    return false
                }

                if (this.shpoUserDto.userOrganizationList) {
                    return true
                } else {
                    return false
                }
            },
            getFirstOrganization () {
                if (!this.shpoUserDto) {
                    return ''
                }

                if (this.shpoUserDto.userOrganizationList) {
                    var item = this.shpoUserDto.userOrganizationList[0]
                    if (item) {
                        return item.description
                    }
                }
            },
            errorMessageClear () {
                this.$store.commit('clearErrors')
            },
            toggleNavItem (data) {
                this[data] = !this[data]
            },
            appendCssFile () {
                //this is to load custom css file based on env
                let file = document.createElement('link')
                file.rel = 'stylesheet'
                file.href = window.location.origin + '/static/css/' + this.$appConfig.css_path
                document.head.appendChild(file)
            }
        }
    }
</script>


<style>
    .errorMessages {
        position: fixed;
        right: 0;
        width: 300px;
        border: 2px solid;
        z-index: 9999;
        margin-top: 10px;
        margin-right: 30px;
    }

    .child-nav {
        max-height: 0px;
    }
</style>



// WEBPACK FOOTER //
// App.vue?4fe622b0